// Mirror of the backend's QUIDAX_MARKET_PRECISIONS table
// (basquet-backend/src/constants/currency.constant.ts:56). Kept in sync
// so the UI can cap the user's amount input at the same dp the backend
// will accept — preventing avoidable round-trips that come back as
// "<CURRENCY> conversion amount cannot have more than N decimal places".
//
// Keys are `${BASE}/${QUOTE}`. Each entry describes how many decimal
// places are allowed for the BASE-side amount and the QUOTE-side amount
// in that market.
const QUIDAX_MARKET_PRECISIONS = {
  'BTC/USDT': { base: 'BTC', quote: 'USDT', baseDp: 5, quoteDp: 2 },
  'BTC/NGN': { base: 'BTC', quote: 'NGN', baseDp: 5, quoteDp: 0 },
  'USDT/NGN': { base: 'USDT', quote: 'NGN', baseDp: 2, quoteDp: 0 },
  'ETH/USDT': { base: 'ETH', quote: 'USDT', baseDp: 4, quoteDp: 2 },
  'ETH/NGN': { base: 'ETH', quote: 'NGN', baseDp: 4, quoteDp: 0 },
  'LTC/USDT': { base: 'LTC', quote: 'USDT', baseDp: 3, quoteDp: 2 },
  'LTC/NGN': { base: 'LTC', quote: 'NGN', baseDp: 3, quoteDp: 0 },
  'QDX/USDT': { base: 'QDX', quote: 'USDT', baseDp: 0, quoteDp: 2 },
  'QDX/NGN': { base: 'QDX', quote: 'NGN', baseDp: 0, quoteDp: 0 },
  'USDC/USDT': { base: 'USDC', quote: 'USDT', baseDp: 2, quoteDp: 2 }
};

// Conservative fallback — if a market isn't in the table (new pair),
// allow up to 8 dp (BTC-style). The backend will reject anything
// stricter than that, but at least the user won't be blocked from
// typing on an unrecognised pair.
const DEFAULT_MAX_DP = 8;

/**
 * Maximum decimal places the FROM-side amount can carry for the given
 * wallet pair, matching what the backend's
 * `assertConversionAmountPrecision` enforces.
 *
 * @param {string} fromSlug e.g. 'NGN'
 * @param {string} toSlug   e.g. 'BTC'
 * @returns {number}
 */
const getMaxDecimalPlaces = (fromSlug, toSlug) => {
  if (!fromSlug || !toSlug) return DEFAULT_MAX_DP;
  const f = String(fromSlug).toUpperCase();
  const t = String(toSlug).toUpperCase();
  const market = QUIDAX_MARKET_PRECISIONS[`${f}/${t}`] || QUIDAX_MARKET_PRECISIONS[`${t}/${f}`];
  if (!market) return DEFAULT_MAX_DP;
  return market.base === f ? market.baseDp : market.quoteDp;
};

export { DEFAULT_MAX_DP, QUIDAX_MARKET_PRECISIONS, getMaxDecimalPlaces };
